import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../UserSlice";

const Login_cbt = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  axios.defaults.baseURL = id;

  const [studid, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [school, setSchool] = useState({});

  const togglePassword = () => {
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus(true);

    try {
        const response = await axios.post("/v3/take-cbt/login", {
        studid,
        password,
        });

        if (response.data.status === "success" && response.data.token) {

        const token = response.data.token;
        localStorage.setItem("token", token);
        const decodedUser = jwtDecode(token); // 🔹 Decode JWT token

        // ✅ Save token & user data in Redux
        dispatch(loginSuccess({ token, user: decodedUser }));

        toast.success("✅ Login successful!");
        
        setTimeout(() => {
            setStatus(false);
            navigate("./home", { state: { user: decodedUser } });
        }, 2000);
        } else {
        throw new Error("Invalid credentials");
        }

    } catch (error) {
        toast.error("❌ Login Failed! Incorrect details.");
        console.error(error);
        setStatus(false);
    }
  };

  const fetchSchool = async () => {
    try {
      const response = await axios.post("/v3/school", { school_id: id });
      if (!response.data || !response.data.schoolname) throw new Error();
      setSchool(response.data);
      localStorage.setItem("schoolname", response.data.schoolname);
    } catch {
      navigate("/nopage");
    }
  };

  useEffect(() => {
    fetchSchool();
  }, [id]);

  return (
    
    <div className="d-lg-flex min-vh-100">
        {/* Left Section */}
        <div
        className="col-md-5 d-flex flex-column px-lg-6 justify-content-center text-white position-relative"
        style={{
            backgroundImage: "url('/assets/images/background/bg-image.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "40% center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh"
        }}
        >
        {/* Dark Overlay */}
        <div
            style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust darkness here
            zIndex: 1
            }}
        />

        {/* Content */}
        <div className="ms-lg-8 position-relative mt-lg-20" style={{ zIndex: 2 }}>
            <div className="mt-lg-20">
            <div className="mb-0">
            <span className="fs-1 fw-medium text-white">{school.schoolname}</span>
            </div>
            <div className="mb-2 mt-n5">
            <span className="fs-t fw-medium text-white">CBT {" "}
            <span className="fs-1">e</span>Stream<span className="fs-1">.</span></span>
            </div>
            <div>
            <p className="text-white font-medium">
                "Prepare with focus, stay away from stress — CBT success leads to exam progress."
            </p>
            <p className="mt-4 text-white">
                "Success is not owned, it's leased — and rent is due every day."
                <i>— J.J. Watt</i>
            </p>
            </div>
            </div>
        </div>
        </div>


        {/* Right Section */}
        <div className="col-md-7 d-flex flex-column text-center justify-content-center align-items-center bg-white text-white px-6 px-lg-15 py-lg-4 py-6">
            <div className="max-w-sm w-full py-6">
            <div className="fs-2 fw-medium mb-2 text-gray-600">Hello Champ'</div>
            <p className="text-sm text-dark mb-6">
                Everything is set for you! <br/>
                Get Ready with CBT Question for today!
            </p>

            <form className="row px-lg-8" onSubmit={handleLogin}>
                <div className="col-lg-12 mb-5">
                <input
                type="text"
                className="form-control form-control-lg bg-back rounded-pill"
                placeholder="What is your student ID?"
                value={studid}
                required
                onChange={(e) => setUsername(e.target.value)}
                />
                </div>

                <div className="form-group mb-3 position-relative">
                    <input
                    type={passwordType}
                    className="form-control form-control-lg bg-back rounded-pill"
                    placeholder="Enter your password"
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                    className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer text-dark"
                    onClick={togglePassword}
                    >
                    <i
                        className={`bi ${
                        passwordType === "password"
                            ? "bi-eye-fill text-dark"
                            : "bi-eye-slash-fill text-dark"
                        }`}
                    ></i>
                    </span>
                </div>

                <div className="col-lg-12">
                <button
                type="submit"
                className="w-50 btn btn-purple py-3 rounded-pill"
                >
                Log in
                </button>
                </div>
                
            </form>

            <div className='col-12 pt-4'>
                    <div className=' pt-6 px-5'>
                        <div className='text-center mb-2'>
                            <span className='fs-5 text-gray-900'>
                              © All rights reserved {new Date().getFullYear()}. Smart Edu Global.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        <ToastContainer />
    </div>

  );
};

export default Login_cbt;
